export default {
  defaultObject () {
    return {
      id: null,
      name: '',
      units: [],
      extremeUnderinflationWarning: 78.0,
      underinflationWarning: 85.0,
      overinflationWarning: 149.5,
      extremeOverinflationWarning: 162.5
    }
  }
}
